var map = {
	"./comodo-secure.png": 1159,
	"./flag-france.png": 1160,
	"./flag-germany.png": 1161,
	"./flag-italy.png": 1162,
	"./flag-netherlands.png": 1163,
	"./flag-portugal.png": 1164,
	"./flag-spain.png": 1165,
	"./flag-usa.png": 1166,
	"./global-cart-seal.png": 1167,
	"./icon-wanelo copy.png": 1168,
	"./icon-wanelo.png": 1169,
	"./icon-whatsapp copy.png": 1170,
	"./icon-whatsapp.png": 1171,
	"./lock.png": 1172,
	"./pagamento-cinza.png": 1173,
	"./pagamento-verde.png": 1174,
	"./pagamento-vermelho.png": 1175,
	"./payment-methods-br.png": 1176,
	"./payment-methods-global.png": 1177,
	"./payment-methods.png": 1178,
	"./pedido-cinza.png": 1179,
	"./pedido-verde.png": 1180,
	"./pedido-vermelho.png": 1181,
	"./selo-ebit-ouro.png": 1182,
	"./selo-eureciclo.png": 1183,
	"./selo-internet-segura.png": 1184,
	"./selo-ra1000.png": 1185,
	"./selo_100-seguro-retina.png": 253,
	"./selo_100-seguro.png": 1186,
	"./selo_site_seguro_certisign.png": 1187,
	"./selo_site_seguro_mcafee.png": 1188,
	"./selo_site_seguro_norton.png": 1189,
	"./selo_site_seguro_norton_small.png": 1190,
	"./separacao-cinza.png": 1191,
	"./separacao-verde.png": 1192,
	"./separacao-vermelho.png": 1193,
	"./shipping-methods-global.png": 1194,
	"./transporte-cinza.png": 1195,
	"./transporte-verde.png": 1196,
	"./transporte-vermelho.png": 1197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1158;